import { RoutePlanSchedule, type ServiceName } from '@models/RoutePlan';
import { createStrings } from '@utils/local';

export const routePlanStrings = createStrings({
  ja: {
    route: 'ルート',
    route2: '航路',
    RECOMMENDED: 'おすすめ順',
    CHEAP: '価格が安い順',
    FAST: '日数が短い順',
    serviceName: 'サービス名',
    routeName: '航路名',
    totalFixedDays: 'ルート固定日数',
    receivingCity: '荷受都市',
    receivingWarehouse: '荷受倉庫',
    exportWarehouse: '輸出倉庫',
    receivingWarehouseDays: '荷受倉庫日数',
    exportWarehouseDays: '輸出倉庫日数',
    seaTransportationDays: '海上運送日数',
    devanDays: 'デバン日数',
    schedule: 'スケジュール',
    warehouseClosingDate: '倉庫搬入カット日',
    pickupDate: '引取予定日',
    eta: 'ETA',
    etd: 'ETD',
  },
} as const);

export const routePlanServiceNameStrings = createStrings({
  ja: {
    D2D: 'D2D',
    'D2DSHENZHEN+': 'D2D Shenzhen+',
    D2DSHENZHEN: 'D2D Shenzhen',
    海上速達便: '海上速達便',
    D2DQINGDAO: 'D2D Qingdao',
  },
});

export const availableServiceNames: ServiceName[] = [
  'D2D',
  'D2DSHENZHEN+',
  'D2DSHENZHEN',
  'D2DQINGDAO',
];

export const weekdays: Record<number, string> = {
  0: '日曜日',
  1: '月曜日',
  2: '火曜日',
  3: '水曜日',
  4: '木曜日',
  5: '金曜日',
  6: '土曜日',
};

export const routePlanScheduleFields: { name: keyof RoutePlanSchedule; label: string }[] = [
  { name: 'warehouse_closing_date', label: routePlanStrings.warehouseClosingDate },
  { name: 'etd', label: 'ETD' },
  { name: 'eta', label: 'ETA' },
  { name: 'pickup_date', label: routePlanStrings.pickupDate },
];
